
export interface IUser {
  userName: string;
  password: string;
  officeID: number;
  aplicacionID: number;
  rolID: number;
  empresaID: number;
  idNivelAcceso: number;
  idEntidad: number;
}

export class User implements IUser {
  public userName: string;
  public password: string;
  public officeID: number;
  public aplicacionID: number;
  public rolID: number;
  public empresaID: number;
  public idNivelAcceso: number;
  public idEntidad: number;

  constructor(userName: string, password: string, officeID: number, aplicacionID: number, rolID: number, empresaID: number, idNivelAcceso: number, idEntidad: number) {
    this.userName = userName;
    this.password = password;
    this.officeID = officeID;
    this.aplicacionID = aplicacionID;
    this.rolID = rolID;
    this.empresaID = empresaID;
    this.idNivelAcceso = idNivelAcceso;
    this.idEntidad = idEntidad;
  }
}
